<template>
    <div class="hidden lg:flex flex-col gap-3 absolute top-1/2 -translate-y-1/2 right-8 z-30">
        <button
            @click="$emit('previous')"
            :disabled="!canGoPrevious"
            class="w-11 h-11 bg-gray-900/90 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-gray-800/90 transition-colors border border-gray-700"
            :class="{ 'opacity-50 cursor-not-allowed': !canGoPrevious }"
        >
            <ChevronUp class="w-5 h-5 text-white" />
        </button>
        <button
            @click="$emit('next')"
            :disabled="!canGoNext"
            class="w-11 h-11 bg-gray-900/90 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-gray-800/90 transition-colors border border-gray-700"
            :class="{ 'opacity-50 cursor-not-allowed': !canGoNext }"
        >
            <ChevronDown class="w-5 h-5 text-white" />
        </button>
    </div>
</template>

<script setup>
import { ChevronUp, ChevronDown } from 'lucide-vue-next'

const props = defineProps({
    canGoPrevious: Boolean,
    canGoNext: Boolean,
})

defineEmits(['previous', 'next'])
</script>
